// Global

// Local
import { Breadcrumb } from './Breadcrumb';
import PlainTextWrapper from 'components/helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import { useBreadcrumbData } from 'lib/hooks/useBreadcrumbData';

export const Default = (): JSX.Element => {
  const breadcrumbData = useBreadcrumbData();
  const filteredAncestors = breadcrumbData?.ancestors || [];

  if (!filteredAncestors.length) return <></>;
  if (filteredAncestors.length <= 1) return <></>;

  /*
   * Rendering
   */
  return (
    <Breadcrumb
      ancestors={filteredAncestors.map((ancestor) => ({
        url: ancestor.url,
        title: <PlainTextWrapper field={{ value: ancestor.title }} />,
      }))}
    />
  );
};
